import { render, staticRenderFns } from "./leadsItemWidget.vue?vue&type=template&id=63ef0d54&scoped=true"
import script from "./leadsItemWidget.vue?vue&type=script&lang=js"
export * from "./leadsItemWidget.vue?vue&type=script&lang=js"
import style0 from "./leadsItemWidget.vue?vue&type=style&index=0&id=63ef0d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef0d54",
  null
  
)

export default component.exports